/*
DO NOT MANUALLY TRANSLATE!
Follow the instructions in the README.md to conveniently update translations.
*/

export default {
  "CookieMessage.old.link": "Mer information",
  "CookieMessage.old.text":
    "För att webbshopen ska fungera optimalt använder vi cookies. Se vår cookie-policy",
  "CookieMessage.link": "Acceptera cookies",
  "CookieMessage.more_information": "Läs mer om Kramp Cookies",
  "CookieMessage.return": "Gå tillbaka",
  "CookieMessage.intro.body":
    "Dessa cookies har placerats av Kramp och av tredje parter. Naturligtvis är vi rädda om er integritet. Genom att klick på Acceptera cookies nedan, godkänner ni att vi får använda dessa. Genom att acceptera dessa cookies, säkerställer du att vår webbplats fungerar korrekt. Exempel på vad dessa används för är:",
  "CookieMessage.intro.list.1": "Automatisk inloggning till Mitt konto",
  "CookieMessage.intro.list.2":
    "Analysera användarbeteende för att förbättra webbshoppen",
  "CookieMessage.intro.list.3":
    "Skapa kundprofiler så att vi kan erbjuda er personanpassad information och annonser",
  "CookieMessage.intro.extra":
    'Om ni inte villacceptera alla cookies kan ni ändra detta i era <a>inställningar</a>. För mer information, läs vår <a href="{legalLink}">privacy and cookie statement</a>',
  "CookieMessage.intro.title": "Kramp använder cookies",
  "CookieMessage.settings.body":
    "Ni kan välja mellan tre cookie-inställningar. Genom att välja standardinställningen kan vi ge er den bästa webbplatsupplevelsen.",
  "CookieMessage.settings.standard.title": "Standard (mest populär):",
  "CookieMessage.settings.standard.body":
    "Cookies används för inloggning, beställning, analys, personlig information, sociala medier och cookies från tredje part.",
  "CookieMessage.settings.restricted.title": "Begränsad:",
  "CookieMessage.settings.restricted.body":
    "Cookies som används för att logga in, beställa, analysera och personlig information.",
  "CookieMessage.settings.highly_restricted.title": "Mycket begränsad:",
  "CookieMessage.settings.highly_restricted.body":
    "Tillåter endast minimalt antal cookies. Används endast för att logga in, beställa och låta webbplatsen fungera i rimlig utsträckning.",
  "CookieMessage.settings.options.title": "Här är vad vi gör:",
  "CookieMessage.settings.option.1":
    "Använd cookies för att säkerställa att denna webbplats fungerar korrekt",
  "CookieMessage.settings.option.2": "Undersöker användarbeteende",
  "CookieMessage.settings.option.3": "Spåra personlig statistik",
  "CookieMessage.settings.option.4":
    "Visa information som kan vara av intresse",
  "CookieMessage.settings.option.5": "Använd information för våra annonser",
  "CookieMessage.settings.option.6": "Spåra anonym statistik",
  "CookieMessage.settings.option.7": "Dela dina personliga uppgifter",
  "CookieMessage.settings.title": "Cookie inställningar",
  "CookiePage.url": "sekretess-cookie-forklaring",
};
